module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.fb59c006.png";